// extracted by mini-css-extract-plugin
export var fullGrid = "_2q-3";
export var pdpPreviewContainer = "_2q-1";
export var previewContainer = "_2q-0";
export var togglePreviewContainer = "_2q-2";